import { string } from 'yup';

const obj = {
  field: [
    {
      title: "Topic or Keyword",
      attr: "language",
      value: "",
      placeholder: "Topic or Keyword",
      label: "Which language are you using, will enable markup highlights",
      type: "text",
      maxLength: 40,
      yup: string().nullable().trim("Initially whitespace are not allowed").required("Topic or Keyword is Required"),

      id: "topic",
      // options: [{ title: "2nd Grader", value: "2nd Grader", desc: "Explain this like I'm 5 years old", Icon: AnnotationIcon },],
      // max: 100,
      min: 3,
      required: true,
      error: "",
      example: `JavaScript`,
    },
    //   {
    //     title: "Code Editor",
    //     attr: "content",
    //     value: "",
    //     id: 2,
    //     placeholder: "function Name(attr){...",
    //     label: "Place some code above to understand how it works",
    //     type: "code",
    //     maxLength: 2000,
    //     // max: 100,
    //     min: 3,
    //     required: true,
    //     error: "",
    //     type: "textarea",
    //     example: `function HelloWorld(text){
    // let text || "Hello World";
    // console.log(text);
    // }`,
    //   },
  ],
  example: [
    {
      title: "Topic or Keyword",
      attr: "language",
      value: "helloword one",
      placeholder: "Topic or Keyword",
      label: "Which language are you using, will enable markup highlights",
      type: "text",
      maxLength: 40,
      yup: string().nullable().trim("Initially whitespace are not allowed").required("Topic or Keyword is  Required"),

      id: "topic",
      // options: [{ title: "2nd Grader", value: "2nd Grader", desc: "Explain this like I'm 5 years old", Icon: AnnotationIcon },],
      // max: 100,
      min: 3,
      required: true,
      error: "",
      example: `JavaScript`,
    },
    //   {
    //     title: "LSI keywords topic",
    //     attr: "content",
    //     value: "Gaming",
    //     id: "topic",
    //     placeholder: "function Name(attr){...",
    //     label: "Place some code above to understand how it works",
    //     type: "code",
    //     maxLength: 2000,
    //     // max: 100,
    //     min: 3,
    //     required: true,
    //     error: "",
    //     type: "textarea",
    //     example: `function HelloWorld(text){
    // let text || "Hello World";
    // console.log(text);
    // }`,
    //   },
  ],
  editor: {
    output: `1. Greeting\n2. Salutation\n3. Communication\n4. Interaction\n5. Welcome Message\n6. Expression of Regards\n7. Saying Hello\n8. Introduction Phrase\n9. Welcoming Statement\n10. Exchange of Pleasantries`,  
   
  },
};

export default obj;
